import React, { useMemo, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import { store } from "../../../global/app/store";
import { client } from "../../../index";
import { GET_LINKING_PAGINATED_DATA } from "../../../screens/Cases/queries";
import {
  fetchFilerCaseDataFail,
  fetchFilerCaseDataSuccess,
} from "../../Form/EntityForm/actions";
import { fetchLinkingCaseData } from "../../SimpleForm/CaseReuse/helpers";
import SimpleModal from "../../SimpleModal";
import getColumns from "../Columns/linkingColumns";
import getHeaderContent from "../_Utils/getHeaderContent";
import { ReactTable } from "../../SimpleForm/ReactTable";

export function SelectPWPage({
  formType,
  toggleModalSequence,
  page,
  setPage,
  resetState,
  isEmergency,
  setSelectedCase,
  queryParameters,
  selectedCase,
  noPrefill,
  setFormVersion,
  searchTerm,
  setSearchTerm,
  setSelectedCaseData,
  addPW,
  isOutOfNetworkView = false,
  setIsOutOfNetworkView = () => {},
}) {
  const [skipPOCStep, setSkipPOCStep] = useState(true);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [casesForLinking, setCasesForLinking] = useState([]);
  const [casesForLinkingLoading, setCasesForLinkingLoading] = useState(true);
  const [pageCount, setPageCount] = useState(0);

  const allowOutOfNetworkLinking = (formType === "9089" && isEmergency === false || formType === "9142B") ;

  const toggleNetworkView = () => {
    if (!casesForLinkingLoading && allowOutOfNetworkLinking) {
      document.getElementById("job-order-search").value = "";
      setCasesForLinking([]);
      setSearchTerm("");
      setSelectedCase(null);
      setIsOutOfNetworkView(!isOutOfNetworkView);
      setPageCount(0);
    }
  };

  // Separately memoized: This column is interactable. We shouldn't re-render the whole table because of a single column. Especially performance impacting due to relying on old version of react-tooltips on each cell.
  let radioColumn = useMemo(() => [
    {
      id: "radio",
      accessor: "",
      Cell: ({
        row: {
          original: { caseNumber },
        },
      }) => {
        return (
          <>
            <input
              type="radio"
              name="pwd-selection"
              title={caseNumber}
              className="usa-radio-input"
              id={`pwd-${caseNumber}`}
              onChange={(e) => e}
              checked={selectedCase === caseNumber}
              onClick={() => {
                setSelectedCase(caseNumber);
              }}
            />
            <label
              className="usa-radio-label"
              htmlFor={`pwd-${caseNumber}`}
              onChange={(e) => e}
              onClick={(e) => setSelectedCase(caseNumber)}
              onKeyUp={(e) => {
                if (e.key === " ") setSelectedCase(caseNumber);
              }}
              checked={selectedCase === caseNumber}
            />
          </>
        );
      },
      disableSortBy: true,
      fixedWidth: 25,
    },
  ]);
  let otherColumns = [];
  let addColumns = getColumns(isEmergency);
  addColumns.forEach((entry) => {
    otherColumns.push(entry);
    return otherColumns;
  });

  const columns = useMemo(() => otherColumns, [casesForLinking]);

  const { header, content, note } = getHeaderContent(
    formType,
    isEmergency,
    isOutOfNetworkView
  );

  const fetchData = async ({ pageSize, pageIndex, sortBy, searchTerm }) => {
    setCasesForLinkingLoading(true);
    if (formType === "9089" || formType === "9142B") {
      queryParameters.UISearch.search = searchTerm;
      queryParameters.UISorting.type = "Linkable";
      queryParameters.UISorting.is_out_of_network = false;
      if (!isOutOfNetworkView) {
        queryParameters.UISorting.page = pageIndex;
        queryParameters.UISorting.limit = pageSize;
        queryParameters.UISorting.sort_ascending = sortBy[0]?.desc ? 1 : 0;
        queryParameters.UISorting.sort_column = sortBy[0]?.id;
      } else {
        if (allowOutOfNetworkLinking && (formType === "9089" || formType === "9142B")) {
          queryParameters.UISorting.page = 0;
          queryParameters.UISorting.limit = 1;
          queryParameters.UISorting.type = "LinkableNonNetwork";
          queryParameters.UISorting.is_out_of_network = true;
        } else {
          setCasesForLinkingLoading(false);
          return;
        }
      }

      let query_params = queryParameters;
      client
        .query({
          query: GET_LINKING_PAGINATED_DATA,
          variables: query_params,
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          const { data, loading, error } = response;

          if (!error && !loading && data) {
            const dataTotalCount = data?.getPaginatedData?.total_count;
            setCasesForLinking(data.getPaginatedData.LinkableCases);
            setPageCount(Math.ceil(dataTotalCount / pageSize));
            setCasesForLinkingLoading(false);
          }
        });
    } else {
      queryParameters.UISorting.page = pageIndex;
      queryParameters.UISorting.limit = pageSize;
      queryParameters.UISorting.sort_ascending = sortBy[0]?.desc ? 1 : 0;
      queryParameters.UISorting.sort_column = sortBy[0]?.id;
      queryParameters.UISearch.search = searchTerm;
      let query_params = queryParameters;
      client
        .query({
          query: GET_LINKING_PAGINATED_DATA,
          variables: query_params,
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          const { data, loading, error } = response;

          if (!error && !loading && data) {
            const dataTotalCount = data?.getPaginatedData?.total_count;
            setCasesForLinking(data.getPaginatedData.LinkableCases);
            setPageCount(Math.ceil(dataTotalCount / pageSize));
            setCasesForLinkingLoading(false);
          }
        });
    }
  };

  const handleFetchCaseData = () => {
    fetchLinkingCaseData(selectedCase, formType)
      .then((data) => {
        if (data) {
          data = data.data.getDatahubCase;
          const fv = data.formVersionId;
          if (formType === "9142C" && fv === 1 && data?.empFein) {
            // SOME old formType FEINS did not have a hyphen for FEIN and some do. just deleting it from import
            delete data.empFein;
          }
          if (formType !== "9035") {
            store.dispatch(fetchFilerCaseDataSuccess(data));
          }
          setSkipPOCStep(fv === 2);
          setFormVersion(fv);
          setFetchLoading(false);

          if (noPrefill) {
            if (formType !== "9035") addPW(selectedCase, data);
            resetState();
          } else {
            setSelectedCaseData(data);
            if (formType === "9142B") fv !== 1 ? setPage(2) : setPage(1);
            if (formType === "9142C") fv === 2 ? setPage(2) : setPage(1);
            if (formType === "9089" || formType === "9035") setPage(2);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        store.dispatch(fetchFilerCaseDataFail(false));
      });
    //   .finally(() => {
    //     // skipPOCStep ? setPage(2) : setPage(1);
    //   });
  };

  const renderSearch = () => (
    <div
      className="usa-search usa-search-big margin-top-2"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div role="search">
        <input
          type={"text"}
          className={"usa-input pwd-input"}
          placeholder={"Type search term here..."}
          id={"job-order-search"}
          onChange={(e) => setSearchTerm(e.target.value.toUpperCase())}
        />
        <button
          type="button"
          className={"usa-button usa-button-primary btn-pwd-search"}
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          Search
        </button>
        <button
          type="button"
          className={"reset-button"}
          onClick={(e) => {
            document.getElementById("job-order-search").value = "";
            setSearchTerm("");
            if (isOutOfNetworkView) {
              setCasesForLinking([]);
            }
          }}
        >
          Reset
        </button>
      </div>
      {allowOutOfNetworkLinking ? (
        <span
          className={`pwd-modal-switch-link ${
            casesForLinkingLoading && "disabled"
          }`}
          onClick={(e) => {
            toggleNetworkView();
          }}
          onKeyUp={(e) => {
            if (e.key === " ") toggleNetworkView();
          }}
        >
          {!isOutOfNetworkView
            ? "Look up PWD Out-of-Network"
            : "Look up PWD In-Network"}
        </span>
      ) : (
        ""
      )}
    </div>
  );

  return (
    <SimpleModal
      toggleModal={toggleModalSequence}
      modalStatus={page === 0}
      renderButton={() => null}
      minWidth={"90%"}
      onRequestClose={() => {
        resetState();
        if (formType === "9089" || formType === "9142B") setIsOutOfNetworkView(false);
      }}
    >
      <h3>{header}</h3>
      <p className="pwd-description">
        {content}
        <br />
        <i>{note}</i>
      </p>

      <div>
        <div className="pwd-search-row">{renderSearch()}</div>
      </div>
      <ReactTable
        loading={casesForLinkingLoading}
        showPagination={!isOutOfNetworkView}
        defaultPageSize={!isOutOfNetworkView ? 10 : 1}
        refetchToFirstPageDependencies={[isOutOfNetworkView]}
        data={casesForLinking}
        fetchData={fetchData}
        pageCount={pageCount}
        searchTerm={searchTerm}
        striped
        tableStyle={{ marginTop: 25 }}
        defaultSortBy={[
          {
            id: "dateSubmitted",
            desc: false,
          },
        ]}
        columns={[...radioColumn, ...columns]}
      />

      <button
        className={"usa-button usa-button-primary modal-submit"}
        disabled={!selectedCase}
        type="button"
        onClick={() => {
          setFetchLoading(true);
          handleFetchCaseData();
        }}
      >
        {noPrefill ? ` Finish ` : ` Continue `}
        <FaSpinner
          style={{
            width: "10px",
            height: "10px",
            marginleft: "8px",
            transition: "width 400ms ease-in-out",
            WebkitTransition: "width 400ms ease-in-out",
            MozTransition: "width 400ms ease-in-out",
          }}
          className={fetchLoading ? "icon-spin" : "hidden"}
        />
      </button>
    </SimpleModal>
  );
}
